const FrontendConfig = { 'env': "ymtechone", 'rp_id': "ymtech.com", 'api_endpoint': "https://api.ymtech.com/v1", 'site_url': "https://secure.ymtech.com/" };
export default FrontendConfig;
